<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-center pt-16>
      <v-flex xs12 pt-5>
        <CarouselItem />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <Products />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <SliderImages />
      </v-flex>
    </v-layout>
    <!-- <v-layout wrap justify-center>
      <v-flex xs12>
        <OurStory :shop="shop"/>
      </v-flex>
    </v-layout> -->
    <v-layout wrap justify-center>
      <v-flex xs12>
        <Feedback :ratings="ratings" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import CarouselItem from "./../Home/carouselItem";
import Products from "./products";
// import OurStory from "./ourStory";
import SliderImages from "./../Home/sliderImages";
import Feedback from "./feedback";
export default {
  components: {
    CarouselItem,
    Products,
    // OurStory,
    SliderImages,
    Feedback,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      slideNo: 0,
      slideInterval: 5000,
      shop:[],
      category:[],
      list: [
        {
          image: require("./../../assets/images/ecoshopbanner.png"),
        },
        {
          image: require("./../../assets/images/Frame 4.png"),
        },
        {
          image: require("./../../assets/images/Frame 5.png"),
        },
      ],
      items: [
        {
          image: require("./../../assets/icons/ThumbsUp.png"),
          name: "Top Quality Products",
        },
        {
          image: require("./../../assets/icons/CreditCard.png"),
          name: "Secure Payment ",
        },
        {
          image: require("./../../assets/icons/Headset.png"),
          name: "24/7 Accessibility",
        },
        {
          image: require("./../../assets/icons/Truck.png"),
          name: "Secure & Fast Delivery",
        },
      ],
      ratings:[],
    };
  },
  computed: {
    sliderHeight() {
      var height = "100%";
      if (this.$vuetify.breakpoint.xl) height = "100%";
      if (this.$vuetify.breakpoint.lg) height = "100%";
      if (this.$vuetify.breakpoint.md) height = "100%";
      if (this.$vuetify.breakpoint.sm) height = "100%";
      if (this.$vuetify.breakpoint.xs) height = "100%";
      return height;
    },
  },
  beforeMount(){
    // this.getData()
  },
  methods:{
    getData() {
      this.appLoading = true;
      axios({
        url: "/sellerView",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          sellerName: this.$route.query.sellerName,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.shop = response.data.data;
          this.ratings=response.data.ratings
          this.$store.commit("sellerData", response.data.data);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  }
};
</script>
<style>
.rectangle {
  height: 100px;
  width: 100%;
  background-color: #555;
}
</style>